export enum ExchangeTabsEnum {
  POSITIONS = 'positions',
  REPLACEMENT_DELIVERY = 'delivery',
  REFUND = 'refund',
  BILLING_INFORMATION = 'billing',
  PREFERENCES = 'preferences',
  DOCUMENTS = 'documents',
}
